<template>
  <div class="d-flex align-start flex-column ga-1">
    <JobBadgeInternal
      v-if="isInternal"
      :class="{ 'mr-2': isEvergreen }"
    />
    <JobBadgeEvergreen
      v-if="isEvergreen"
    />
  </div>
</template>

<script>
import JobBadgeInternal from './JobBadgeInternal.vue';
import JobBadgeEvergreen from './JobBadgeEvergreen.vue';

export default {
  name: 'JobBadges',
  components: { JobBadgeInternal, JobBadgeEvergreen },
  props: {
    isInternal: { type: Boolean, default: false },
    isEvergreen: { type: Boolean, default: false },
  },
};
</script>
